import { murmur3 } from 'murmurhash-js';

export class Murmurhash3 {
  static murmur3(key: string, seed: number = 0): number {
    return murmur3(key, seed);
  }
}
